import { Injectable } from '@angular/core';
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { AuthService } from '@services/auth.service';
import { Observable } from 'rxjs/observable';
import "rxjs/add/operator/map"; 
import { CommonMethods } from './common.method';

@Injectable()
export class LoginRouteGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private commonMethod: CommonMethods
  ) { }
  canGoToRoute(user: string, id: string): boolean {
    return true;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (CommonMethods.CheckNullOrUndefined(this.auth.getCompanyId()) || CommonMethods.CheckNullOrUndefined(this.auth.getToken())) {
      setTimeout(() => {
        this.auth.clearStorage();
      }, 0);
      return true;
    }
    this.router.navigate(['/home'])
    return false;
  }
}